// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"ef055025","name":"b84444d7","position":"fe4358a4","noName":"c9336d6e","record":"e0b462cb","recordSelected":"c4801fba"};